import type { FunctionComponent } from "react";

import type {
  ContentSchemaRenderProps,
  RenderComponent,
  RenderMap,
} from "~/components/content/content-schema-render/index";

import { isTrackViewedPercentageSchema, TrackViewedPercentageSchemaType } from "./schemas";
import { TrackPercentageBlock } from "./styles";

export const useTrackViewedPercentageRender = () => {
  const trackViewedPercentageRenders: RenderMap<
    RenderComponent<ContentSchemaRenderProps, FunctionComponent<ContentSchemaRenderProps>>
  > = {
    [TrackViewedPercentageSchemaType]: ({ schemaNode }: ContentSchemaRenderProps) => {
      if (!isTrackViewedPercentageSchema(schemaNode)) return null;

      return (
        <TrackPercentageBlock
          className={`js-reading-${schemaNode.attribs.percentage}-percent-completion-tracker`}
        />
      );
    },
  };

  return {
    trackViewedPercentageRenders,
  };
};
